module.exports = "/fonts/hashed/NotoSansKR-Regular.9fab5e13.ttf.gz.bin";